export const EscrowActivityTestIds = {
  // EscrowActivity.js
  RECORD_BUTTON: 'escrow-activity.record-button',

  // EscrowDisbursementDrawerContent.js
  DISBURSEMENT_DATE: 'disbursement-form.disbursement-date',
  TYPE_SELECT: 'disbursement-form.type-select',
  PAYEE_NAME_INPUT: 'disbursement-form.payee-name-input',
  REFERENCE_NUMBER_INPUT: 'disbursement-form.reference-number-input',
  NOTES_INPUT: 'disbursement-form.notes-input',
};
